import cf from './cf';
import i1yv_20211024 from './i1yv_20211024';

export default class i1yv1a extends i1yv_20211024 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.class = 'i1yv1a';
    this.d_viewDefs = {
      name: 'エントリー抽選'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
